// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__k7Byy","buttons":"RemoveExpirationActionButtons_buttons__205It"};